import { render, staticRenderFns } from "./MarshallConfig.vue?vue&type=template&id=41507272&"
import script from "./MarshallConfig.vue?vue&type=script&lang=js&"
export * from "./MarshallConfig.vue?vue&type=script&lang=js&"
import style0 from "./MarshallConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MarshallConfig.vue"
export default component.exports